export * from './src/email-marketing-v1-account-details-account-details.schemas.js';
